// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fsel-row {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
  flex-wrap: wrap;
}

.fsel-dropdown-wrapper {
  position: relative;
}

.fsel-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  background: var(--an-surface, white);
  border: 1px solid var(--an-border, #ddd);
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 280px;
  max-height: 400px;
  overflow-y: auto;
  margin-top: 4px;
  padding: 8px 0;
}

.fsel-dropdown-header {
  padding: 8px 14px;
  border-bottom: 1px solid var(--an-border-soft, #eee);
  font-weight: 600;
  font-size: 14px;
  color: var(--an-text, #333);
}

.fsel-checkbox-row {
  display: flex;
  align-items: center;
  padding: 10px 14px;
  cursor: pointer;
  font-size: 14px;
  gap: 10px;
  border-bottom: 1px solid var(--an-border-soft, #f5f5f5);
  color: var(--an-text, inherit);
}

.fsel-checkbox-row:hover {
  background-color: var(--an-surface-hover, #f5f5f5);
}

.fsel-checkbox {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: var(--an-accent, #0073cf);
}

.fsel-empty-text {
  font-size: 12px;
  color: var(--an-text-faint, #999);
}

.fsel-chips-row {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  align-items: center;
}

.fsel-chips-label {
  font-size: 14px;
  color: var(--an-text-muted, #666);
}

.fsel-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 4px 10px;
  background-color: var(--an-accent-soft, #e8f4fc);
  border: 1px solid var(--an-accent, #0073cf);
  border-radius: 16px;
  font-size: 13px;
  color: var(--an-accent, #0073cf);
}

.fsel-chip-remove-wrapper {
  cursor: pointer;
  display: flex;
  align-items: center;
}

.fsel-clear-all {
  padding: 4px 10px;
  border: 1px solid var(--an-critical, #dc3545);
  background: transparent;
  color: var(--an-critical, #dc3545);
  border-radius: 16px;
  cursor: pointer;
  font-size: 12px;
  margin-left: 8px;
}

.fsel-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Home/FilterSelector.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,aAAa;EACb,oCAAoC;EACpC,wCAAwC;EACxC,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,oDAAoD;EACpD,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,SAAS;EACT,uDAAuD;EACvD,8BAA8B;AAChC;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gDAAgD;EAChD,2CAA2C;EAC3C,mBAAmB;EACnB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,6CAA6C;EAC7C,uBAAuB;EACvB,kCAAkC;EAClC,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;AACd","sourcesContent":[".fsel-row {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 1rem;\n  flex-wrap: wrap;\n}\n\n.fsel-dropdown-wrapper {\n  position: relative;\n}\n\n.fsel-dropdown {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 1000;\n  background: var(--an-surface, white);\n  border: 1px solid var(--an-border, #ddd);\n  border-radius: 4px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  min-width: 280px;\n  max-height: 400px;\n  overflow-y: auto;\n  margin-top: 4px;\n  padding: 8px 0;\n}\n\n.fsel-dropdown-header {\n  padding: 8px 14px;\n  border-bottom: 1px solid var(--an-border-soft, #eee);\n  font-weight: 600;\n  font-size: 14px;\n  color: var(--an-text, #333);\n}\n\n.fsel-checkbox-row {\n  display: flex;\n  align-items: center;\n  padding: 10px 14px;\n  cursor: pointer;\n  font-size: 14px;\n  gap: 10px;\n  border-bottom: 1px solid var(--an-border-soft, #f5f5f5);\n  color: var(--an-text, inherit);\n}\n\n.fsel-checkbox-row:hover {\n  background-color: var(--an-surface-hover, #f5f5f5);\n}\n\n.fsel-checkbox {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n  accent-color: var(--an-accent, #0073cf);\n}\n\n.fsel-empty-text {\n  font-size: 12px;\n  color: var(--an-text-faint, #999);\n}\n\n.fsel-chips-row {\n  display: flex;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n.fsel-chips-label {\n  font-size: 14px;\n  color: var(--an-text-muted, #666);\n}\n\n.fsel-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 4px 10px;\n  background-color: var(--an-accent-soft, #e8f4fc);\n  border: 1px solid var(--an-accent, #0073cf);\n  border-radius: 16px;\n  font-size: 13px;\n  color: var(--an-accent, #0073cf);\n}\n\n.fsel-chip-remove-wrapper {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n}\n\n.fsel-clear-all {\n  padding: 4px 10px;\n  border: 1px solid var(--an-critical, #dc3545);\n  background: transparent;\n  color: var(--an-critical, #dc3545);\n  border-radius: 16px;\n  cursor: pointer;\n  font-size: 12px;\n  margin-left: 8px;\n}\n\n.fsel-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 999;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
